
import { InputCheckbox, InputNumber, InputText, InputTextarea, InputSelect } from '@/components/inputs'
import { FormPage } from '@/mixins'
import { Services } from 'tradingmate-modules/src/services'
import { Component, Mixins, Prop } from 'vue-property-decorator'
import { BusinessBranchModel, SocialLinkType } from 'tradingmate-modules/src/models/api/businesses'
import BusinessBranchDetailUpdateModel from 'tradingmate-modules/src/models/api/businesses/BusinessBranchDetailUpdateModel'
import BusinessBranchStates from 'tradingmate-modules/src/models/api/businesses/BusinessBranchStates'
import BusinessBranchDisplayAddress from 'tradingmate-modules/src/models/api/businesses/BusinessBranchDisplayAddress'
import BusinessBranchNumEmployees from 'tradingmate-modules/src/models/api/businesses/BusinessBranchNumEmployees'
import FormCheckboxField from '@/components/forms/FormCheckboxField.vue'
import { DropdownListItem } from 'tradingmate-modules/src/forms'

@Component({
  components: {
    InputCheckbox,
    FormCheckboxField,
    InputNumber,
    InputText,
    InputTextarea,
    InputSelect
  }
})

export default class BrandingEditor extends Mixins(FormPage) {
  @Prop({ required: true })
  private value!: BusinessBranchModel;

  private abnDebounce: number | undefined = undefined
  private branchDebounce: number | undefined = undefined
  private npcDebounce: number | undefined = undefined

  private displayAddressSelections: DropdownListItem[] = [
    { Key: 'Display', Label: 'Display', Value: BusinessBranchDisplayAddress.Display },
    { Key: 'Do not display', Label: 'Do not display', Value: BusinessBranchDisplayAddress.DoNotDisplay },
    { Key: 'Suburb only', Label: 'Suburb only', Value: BusinessBranchDisplayAddress.SuburbOnly }
  ]

  private states: DropdownListItem[] = [
    { Key: BusinessBranchStates.Queensland, Label: 'Queensland', Value: BusinessBranchStates.Queensland },
    { Key: BusinessBranchStates.NewSouthWales, Label: 'New South Wales', Value: BusinessBranchStates.NewSouthWales },
    { Key: BusinessBranchStates.Victoria, Label: 'Victoria', Value: BusinessBranchStates.Victoria },
    { Key: BusinessBranchStates.Tasmania, Label: 'Tasmania', Value: BusinessBranchStates.Tasmania },
    { Key: BusinessBranchStates.SouthAustralia, Label: 'South Australia', Value: BusinessBranchStates.SouthAustralia },
    { Key: BusinessBranchStates.WesternAustralia, Label: 'Western Australia', Value: BusinessBranchStates.WesternAustralia },
    { Key: BusinessBranchStates.NorthernTerritory, Label: 'Northern Territory', Value: BusinessBranchStates.NorthernTerritory },
    { Key: BusinessBranchStates.AustralianCapitalTerritory, Label: 'ACT', Value: BusinessBranchStates.AustralianCapitalTerritory }
  ]

  updateAbn (): void {
    window.clearTimeout(this.abnDebounce)
    if (!this.value) return
    this.abnDebounce = window.setTimeout(() => {
      Services.API.Businesses.UpdateAbn(
        this.value.BusinessBranchId,
        { ABN: this.value.ABN }
      ).catch((error) => { this.httpError = error })
    }, 1000)
  }

  updateBranch (): void {
    window.clearTimeout(this.branchDebounce)
    if (!this.value) return

    var branchUpdateModel: BusinessBranchDetailUpdateModel = {
      ABN: this.value.ABN,
      NoABNReason: '',
      TradingAddress: this.value.TradingAddress,
      Suburb: this.value.Suburb,
      PostCode: this.value.Postcode,
      StateId: BusinessBranchStates[this.getBusinessBranchState(this.value.StateId)],
      DisplayAddress: this.value.DisplayAddress,
      PostalAddress: this.value.PostalAddress,
      NumEmployees: BusinessBranchNumEmployees.oneToFourteen,
      NonProfitCharity: this.value.NonProfitCharity
    }

    this.branchDebounce = window.setTimeout(() => {
      Services.API.Businesses.UpdateBusinessBranchDetails(this.value.BusinessBranchId, branchUpdateModel)
        .catch((errors) => {
          this.httpError = errors
        }).finally(() => {
          this.loading = false
        })
    }, 1000)
  }

  updateNonProfitCharity (): void {
    window.clearTimeout(this.npcDebounce)
    if (!this.value) return
    this.abnDebounce = window.setTimeout(() => {
      Services.API.Businesses.UpdateNpc(
        this.value.BusinessBranchId,
        { NonProfitCharity: this.value.NonProfitCharity }
      ).catch((error) => { this.httpError = error })
    }, 1000)
  }

  getBusinessBranchState (value: string): keyof typeof BusinessBranchStates {
    var result = (Object.keys(BusinessBranchStates) as Array<keyof typeof BusinessBranchStates>).find(key => BusinessBranchStates[key] === value)

    if (!result) {
      throw new Error(`Invalid BusinessBranchState value: ${value}`)
    }

    return result
  }
}

